import { render, staticRenderFns } from "./FilePermissionsChip.vue?vue&type=template&id=24d6ab90&scoped=true&"
import script from "./FilePermissionsChip.vue?vue&type=script&lang=ts&"
export * from "./FilePermissionsChip.vue?vue&type=script&lang=ts&"
import style0 from "./FilePermissionsChip.vue?vue&type=style&index=0&id=24d6ab90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6ab90",
  null
  
)

export default component.exports